exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proposal-logo[data-v-0480cc96] {\n  display: block;\n  height: 100%;\n  width: 100%;\n  min-height: 50px;\n  background-position: center right;\n  background-size: contain;\n  background-repeat: no-repeat;\n}", ""]);

// exports
